import React from 'react';
const facts = [{
  value: '6 + 5',
  label: 'Volumes & bonuses'
}, {
  value: '90',
  label: 'Sessions ready to run'
}, {
  value: '3',
  label: 'Stations every session'
}, {
  value: '0',
  label: 'Kids waiting in the queue'
}];
export function SocialProofBar() {
  return <section className="w-full bg-field-mid" data-id="element-320" data-mp="25su9ddcu3tke">
      <div className="mx-auto max-w-6xl px-5 py-10 sm:py-12" data-id="element-321" data-mp="25u5bz9ujmv9x">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-field-line bg-field-line sm:grid-cols-4" data-id="element-322" data-mp="32iusavqivfts">
          {facts.map(fact => <div key={fact.label} className="bg-field px-4 py-5 text-center" data-id="element-323" data-mp="2xhxcgpszixvg">
              <div className="font-display text-4xl font-extrabold leading-none text-willow sm:text-5xl" data-id="element-324" data-mp="2tgvaw2bli9qb">
                {fact.value}
              </div>
              <div className="mt-1.5 text-[10px] font-semibold uppercase tracking-widest text-cream/65" data-id="element-325" data-mp="1i2ztso14rqwg">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}